import { apiClient } from '~/api/client'
import type { StatsResponse, Timeseries } from '~/api/types'

// 운영 대시보드 통계 API. 통계(스냅샷)와 기간 시계열(추이)을 가져온다.

/** GET /admin/api/stats — 크로스서비스 운영 통계 스냅샷. */
export function getStats() {
    return apiClient.get<StatsResponse>('/stats')
}

/** GET /admin/api/stats/timeseries?days=N — 기간 활동 추이(N=7|30|90, 7~90 clamp). */
export function getTimeseries(days: number) {
    return apiClient.get<Timeseries>(`/stats/timeseries?days=${days}`)
}
